import { useTimelineSubtextStyles } from './timeline-subtext.styles';

export function TimelineSubtext({ text }: { text: string }) {
  const classes = useTimelineSubtextStyles();
  return <p className={classes.text}>({text})</p>;
}
